import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectStatusList } from "../../features/status";
import Status from "./Status";
import { selectAllStatus } from "../../features/applicationStatus";
import { selectAllUsers } from "../../features/user";
import { getLoggedUser } from "../../features/user";

export const StatusBar = ({ props }) => {
  const userList = useSelector(selectAllUsers);
  const statusList = useSelector(selectStatusList);
  const applicationStatusList = useSelector(selectAllStatus);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentAppStatus, setCurrentAppStatus] = useState(null);
  const [sortedStatus, setSortedStatus] = useState(null);

  const [displayStatus, setDisplayStatus] = useState(null);
  const [appLength, setApplength] = useState(null);
  const loggedUser = useSelector(getLoggedUser);
  useEffect(() => {
    if (applicationStatus) {
      const sorted_status = props.statusList.slice().sort((a, b) => {
        return parseInt(a.statusId) - parseInt(b.statusId);
      });

      setSortedStatus(sorted_status);

      //extra status are being passed so index doesn't align with counter
      let counter = 0;
      const temp = [];
      for (let i = 0; i < sorted_status?.length; i++) {
        if (
          (sorted_status[i].milestone && !sorted_status[i].deleted) || //display status if status is a miletestone or any current application status regardless of milestone flag
          (parseInt(sorted_status[i].statusId) ===
            parseInt(applicationStatus.statusId) &&
            !sorted_status[i].deleted)
        ) {
          counter += 1;
          temp.push(sorted_status[i]);
        }
      }
      setApplength(counter);
      setDisplayStatus(temp);
    }
  }, [props.statusList, applicationStatus]);

  useEffect(() => {
    if (applicationStatusList && applicationStatusList?.length > 0) {
      const temp = applicationStatusList.filter((status) => {
        return status.applicationId === props.appId;
      });

      if (temp?.length > 0) {
        const statusId = temp[0].statusId;
        if (statusList?.length > 0) {
          const statusInfo = statusList.filter((status) => {
            // return parseInt(status.statusId) === statusId;
            return status.id === statusId;
          });
          setCurrentAppStatus(statusInfo[0]);
        }
      }
    }
  }, [applicationStatusList, props.appId]);

  useEffect(() => {
    if (applicationStatusList) {
      const temp = applicationStatusList.filter((status) => {
        return status.applicationId === props.appId;
      });
      if (temp?.length > 0) {
        const statusId = temp[0].statusId;
        const statusObj = statusList.filter((status) => {
          return (
            // parseInt(status.statusId) === statusId &&
            status.id === statusId &&
            status.programId === props.program.id
          );
        });
        setApplicationStatus(statusObj[0]);
      }
    }
  }, [applicationStatusList, props.program]);

  const setStatus = async (status) => {
    try {
      const statusObj = {
        id: applicationStatusList?.filter((status) => {
          return status.applicationId === props.appId;
        })[0].id,
        statusId: parseInt(status),
        applicationId: props.appId,
        adminRespond: false,
      };
      props.saveStatus(statusObj);
    } catch (err) {
      console.log(err);
    }
  };

  const [statusDescription, setStatusDescription] = useState("");
  return (
    <div className={`gap-8  ${props.format === "table" ? "" : "gap-4"}`}>
      {loggedUser && loggedUser.role === "ADMIN" && (
        <div className="p-2 md:p-4 flex flex-col">
          <span className="tracking-wide font-bold text-blue-reef">
            Workflow
          </span>
          <span>{`Application ID: ${props.appId}`}</span>
        </div>
      )}
      {applicationStatus && appLength && (
        <div 
          className="flex gap-3 md:gap-5 justify-center md:p-4 overflow-x-auto"
          ref={(el) => {
            if (el && el.scrollWidth > el.clientWidth) {
              el.classList.remove('justify-center');
              el.classList.add('justify-start');
            }
          }}
        >
          {displayStatus &&
            displayStatus.map((status, index) => {
              return (
                <div key={index}>
                  <Status
                    key={index}
                    index={index}
                    currentStep={currentStep}
                    className="text-black"
                    props={status}
                    customer={props.customer}
                    statusLength={appLength}
                    status={applicationStatus}
                  />
                </div>
              );
            })}
        </div>
      )}

      {props.customer === false && currentAppStatus && (
        <div className="flex flex-col justify-center gap-3 md:gap-4 md:p-4">
          {currentAppStatus && applicationStatus && (
            <div className="flex flex-col md:flex-row md:gap-2 text-base">
              <label htmlFor="">Current Status Description: </label>
              <span className="text-sm md:text-base">{applicationStatus.description}</span>
            </div>
          )}
          <div className="flex flex-col md:flex-row md:gap-2 md:items-center text-base">
            <label htmlFor="">Change Status to: </label>
            <select
              name=""
              id=""
              className="border w-full md:w-[20rem] h-[2.5rem] rounded text-sm md:text-base"
              onChange={(e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const currentName = selectedOption.getAttribute("data-name");
                const currentDescription =
                  selectedOption.getAttribute("data-description");
                const currentNumber =
                  selectedOption.getAttribute("data-number");
                const currentId =
                  selectedOption.getAttribute("data-Id");

                props.addStatusNumber(currentNumber);
                setStatusDescription(currentDescription);
                props.addStatusName(currentName);
                props.addStatusId(currentId);
                // setStatus(e.target.value);
                setStatus(currentId);
              }}
            >
              <option value="" disabled selected>
                Select Next Status
              </option>
              {sortedStatus &&
                sortedStatus
                  .filter((x) => {
                    return !x.deleted;
                  })
                  .map((status, index) => {
                    return (
                      <option
                        value={status.statusId}
                        data-name={status.name}
                        data-description={status.description}
                        data-number={status.number}
                        data-id={status.id}
                        key={index}
                      >
                        {`${status.number} - ${status.name}`}
                      </option>
                    );
                  })}
            </select>
          </div>

          <div className="flex flex-col md:flex-row md:gap-2 text-base">
            <span>New Status Description:</span>
            <span className="text-sm md:text-base">{statusDescription}</span>
          </div>
          <div className="flex flex-col md:flex-row md:gap-2 md:items-center text-base">
            <label htmlFor="">Change Staff Assignment To: </label>
            <select
              name=""
              id=""
              className="border w-full md:w-[20rem] h-[2.5rem] rounded text-sm md:text-base"
              onChange={(e) => {
                props.addAsignee(e.target.value);
              }}
            >
              <option value="" disabled selected>
                Select Staff Name
              </option>
              {userList &&
                userList.map((user, index) => {
                  if (!user.deleted) {
                    return (
                      <option value={user.id} key={index}>
                        {`${user.firstName} ${user.lastName}`}
                      </option>
                    );
                  }
                })}
            </select>
          </div>

          {/* {props.statusList.length === 0 && <span>hello</span>} */}
        </div>
      )}
    </div>
  );
};

export default StatusBar;
